<template>
  <transition name="fade">
    <div class="award-record-mask" v-if="show"></div>
  </transition>

  <transition name="popup">
    <div class="award-record-box" v-if="show">
      <div class="award-record-title">Record</div>
      <div class="award-record-list" v-if="records && records.length">
        <div class="award-record-th">
          <span class="award-record-th-prize">Prize</span>
          <span class="award-record-th-time">Time</span>
        </div>
        <div class="award-record-trs">
          <div class="award-record-tr" v-for="(item, idx) in records" :key="idx">
          <span class="award-record-tr-prize">{{item.reward_name}}</span>
          <span class="award-record-tr-time">{{item.reward_time}}</span>
          </div>
        </div>
      </div>
      <div class="record-empty" v-else>
        Sorry, no prize yet
      </div>
      <div class="award-record-close" @click="close">×</div>
    </div>
  </transition>
 
  
</template>

<script lang="ts" setup>
import { computed, onMounted, onUnmounted, ref, toRefs, defineEmits, reactive, watch } from 'vue';
import roomService from '@/service/room';

const props = withDefaults(defineProps<{
  show: boolean; // 容器是否展示
}>(), 
{ 
  show: false, 
}
);
const {show} = toRefs(props);
const emit = defineEmits(['update:show']);
const close = () => {
  console.log('close');
  emit('update:show', false);
};

const records = ref<any[]>([]);
const getRecords = async () => {
  try{
    const {data} = await roomService.getRechargeBarReward();
    records.value = data.recharge_bar_reward_record;
  }catch(e){
    console.log(e);
  }
};

watch(show, async(newVal) => {
  if(newVal){
    await getRecords();
  }
});

onMounted(async() => {
  await getRecords();
});

</script>

<style lang="less" scoped>
.award-record-mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background: rgba(0, 0, 0, 0.45);
}

.award-record-box {
  width: 3.16rem;
  height: 3.59rem;
  background: #fff;
  border-radius: 0.22rem;
  padding-top: 0.24rem;
  position: fixed;
  top: 0.3rem;
  left: 0.3rem;
  z-index: 2;
  transform: translateY(0);

  .award-record-title {
    font-family: PingFangSC-Semibold;
    font-size: 0.18rem;
    color: #1a1a1a;
    letter-spacing: 0;
    text-align: center;
    font-weight: 600;
    line-height: 0.25rem;
  }

  .award-record-list {
    padding: 0 0.08rem;
    margin-top: 0.1rem;

    .award-record-th {
      display: flex;
      background: rgba(12, 118, 91, 0.27);
      font-family: NotoSans;
      font-size: 0.14rem;
      color: #333;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
      height: 0.3rem;
      line-height: 0.3rem;

      .award-record-th-prize {
        width: 1.68rem;
      }

      .award-record-th-time {
        width: 1.32rem;
      }
    }

    .award-record-trs {
      overflow: auto;
      height: 2.5rem;
    }

    .award-record-tr {
      display: flex;
      text-align: center;
      border-bottom: 1px solid rgba(153, 153, 153, 0.3);
      font-family: NotoSans;
      font-size: 0.12rem;
      color: #333;
      letter-spacing: 0;
      font-weight: 400;
      height: 0.32rem;
      line-height: 0.32rem;

      .award-record-tr-prize {
        width: 1.68rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .award-record-tr-time {
        width: 1.32rem;
      }
    }
  }

  .record-empty {
    margin-top: 0.8rem;
    height: 1.5rem;
    width: 100%;
    background: url("@/assets/charge-strip/record-empty.png") no-repeat top center;
    background-size: 1.68rem;
    padding-top: 1.02rem;
    font-family: NotoSans;
    font-size: 0.14rem;
    color: #333;
    letter-spacing: 0;
    line-height: 0.36rem;
    font-weight: 400;
    text-align: center;
  }
}

.award-record-close {
  position: absolute;
  z-index: 1;
  left: 50%;
  bottom: -0.5rem;
  transform: translateX(-50%);
  width: 0.32rem;
  height: 0.32rem;
  border-radius: 50%;
  border: 0.02rem solid #eee;
  color: #eee;
  text-align: center;
  line-height: 0.28rem;
  font-size: 0.32rem;
  cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.popup-enter-active,
.popup-leave-active {
  transition: transform 0.4s ease;
}

.popup-enter-from,
.popup-leave-to {
  transform: translateY(100vh);
}
</style>